<template>

    <div class="mo-mask" v-show="isModalVisible">
        <div class="mo-wrapper pos-rel" >
        
            <img class="mo-bg" src="../assets/img/p8.png"/>
            
            <div class="mo-close" @click="this.isModalVisible=false;">X</div>
            <div class="mo-content">
                <div class="row">
                    <div class="col-sm-6">
                        <div class="welc title-p f-green" style="font-size:56px;">Welcome!</div>
                    </div>
                    <div class="col-sm-6">
                        <div class="login">
                            <div class="f-green t-center" style="font-size:28px;">Sign in</div>
                            <label>Username</label>
                            <input type="email" v-model="LoginForm.username"><br><br>
                            <label>Password</label>
                            <input type="password" v-model="LoginForm.password"><br><br>
                            <br><br>
                            <div class="t-right"><div class="btn-dark" @click="signIn()" >Sign In</div></div>
                        </div>
                    </div>
                </div>

            </div>
            
        </div>
    </div>

    
</template>

<script>
    export default {
        name: 'SignIn',
        data() {
            return {
                isModalVisible: false,
                LoginForm: { username: 'tan@cellflare.com', password: 'Abc123' }
            }
        },
        mounted() {
            if (this.$route.query.usr != null && this.$route.query.usr != undefined) {
                this.LoginForm.username = this.$route.query.usr;
                this.LoginForm.password = '';
            }
        },
        methods: {
            show() {
                this.isModalVisible = true;
            },
            signIn() {
                
                this.$core.SignIn(this.LoginForm).then((data) => {
                    if (data.Message!='') {
                        this.$ui.alert(this, "Error", data.Message, "error");
                    } else {
                        
                        var key = this.$route.query.key;
                        this.$core.data.UserInfo = data.Object;
                        this.$core.data.DisplayPage = 'Info';
                        if (key != null && key != undefined) {
                            this.$core.CheckHasContractToSign(key).then((x) => {
                                //console.log(`After login contract is ${x} for sign`);
                                if (x == true) {
                                    window.open(`/Signature?key=${key}`, '');
                                }
                            });
                        }
                        
                        this.$router.push('/PersonalInfo/0');

                        //add user and user id to session.
                        sessionStorage.setItem("user", JSON.stringify(data.Object));
                        sessionStorage.setItem("UserId", data.Object.UserId);
                        sessionStorage.setItem("UserName", data.Object.UserName);
                    }
                   
                });
                
            },
            terms() {
                //console.log("terms");
            }
            
        }
    };
</script>


